import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { flowRight } from 'lodash';
import { store } from '../store';
import { ComponentDesc } from '../store';
import withStyles, { WithStyles } from 'react-jss';
import { SketchPicker } from 'react-color';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import { ChromePicker } from 'react-color';
import reactCSS from 'reactcss';

import { settingsPanelStyles as styles } from './styles';
import ReactTooltip from 'react-tooltip';

const color_picker = require('../components/icons/color_picker.svg');
//import { settingsPanelStyles as styles } from "../components/common/styles";

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

const styles = {
    root: {
        //paddingLeft: 5,
        padding: 10,
        //margin: 10,
        height: 'auto',
        backgroundColor: '#F2F2F5',
        color: '#a0aabf',
        borderBottom: '1px solid #CDCED1',
    },
    subroot: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: 25,
        align: 'center',
    },
    item: {
        flexBasis: '50%',
    },
    header: {
        color: '#2F343E',
        fontSize: 12,
    },
    inputBox: {},

    input: {
        width: 60,
        height: 25,
        textAlign: 'center',
        borderRadius: 5,
        backgroundColor: '#FFFFFF',
        color: '#A0AAA2',
        border: 'none',
        //   marginLeft: '20px',
    },

    widthslider: {
        width: 100,
        height: 5,
        marginLeft: '10px',
    },

    title: {
        fontSize: '18px',
        marginLeft: '40px',
        //marginBottom:'20px',
        color: '#2F343E',
    },
    icon: {
        color: '#FFBF5B',
    },
    sub_header: {
        color: '#FFBF5B',
        textAlign: 'center',
    },
    panel: {
        marginBottom: '10px',
        marginTop: '10px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
};

interface IProps extends WithStyles<typeof styles> {
    type: string;
}

class ComponentsList extends Component<IProps, any> {
    state = {
        displayBackgroundpicker: false,
        displayColorPicker: false,
        color: {
            r: '0',
            g: '0',
            b: '0',
        },
        isExpanded: false,
    };
    handleOnChange = (value) => {
        store.currentTemplate.pageSettings.width = value;
    };
    handlePadding = (abc) => {
        store.currentTemplate.pageSettings.padding = +abc.target.value;
    };
    handlePaddingRight = (right) => {
        store.currentTemplate.pageSettings.paddingRight = +right.target.value;
    };
    handleOnChangeWidth = (value) => {
        store.currentTemplate.pageSettings.width = value;
    };
    handleOnChangeBackground = (value) => {
        store.currentTemplate.pageSettings.backgroundColor = value.hex;
    };
    handleClickBackgroundColor = () => {
        this.setState({
            displayBackgroundpicker: !this.state.displayBackgroundpicker,
        });
    };
    handleCloseBackgroundColor = () => {
        this.setState({ displayBackgroundpicker: false });
    };
    handleOnChangeColor = (value) => {
        store.currentTemplate.pageSettings.color = value.hex;
    };

    handleCloseColor = () => {
        this.setState({ displayColorPicker: false });
    };
    handleClickColor = () => {
        this.setState({
            displayColorPicker: !this.state.displayColorPicker,
        });
    };

    constructor(props, context) {
        super(props, context);
    }

    updateAllPaddings(r) {
        this.props.descriptor.style.paddingTop = r;
        this.props.descriptor.style.paddingLeft = r;
        this.props.descriptor.style.paddingRight = r;
        this.props.descriptor.style.paddingBottom = r;
    }

    render() {
        const { classes } = this.props;
        let { descriptor } = this.props;
        const styles = reactCSS({
            default: {
                color: {
                    width: '50px',
                    height: '14px',
                    borderRadius: '2px',
                    marginLeft: '0px',
                    background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b})`,
                },

                swatch: {
                    padding: '5px',
                    background: '#DDDDDD',
                    borderRadius: '1px',
                    boxShadow: '#DDDDDD',
                    display: 'inline-block',
                    cursor: 'pointer',
                    width: 50,
                    marginLeft: '5px',
                },
                popover: {
                    position: 'absolute',
                    right: '35px',
                    top: '31px',
                    zIndex: 1,
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <div>
                <div className={classes.subroot}>
                    <span className={classes.title} style={{ marginBottom: '10px', marginLeft: '8px' }}>
                        Global Settings
                    </span>
                </div>
                <div className={classes.root} style={{ position: 'relative' }}>
                    {' '}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                        }}>
                        <span
                            className={classes.header}
                            style={{
                                width: '130px',
                            }}>
                            Padding
                        </span>

                        <input style={{ width: '110px' }} type="number" className={classes.input + ' paddingInputbox'} value={store.currentTemplate.pageSettings.padding} onChange={this.handlePadding} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                            position: 'relative',
                        }}>
                        <span
                            className={classes.header}
                            style={{
                                width: '130px',
                            }}>
                            Background Color
                        </span>

                        <button
                            style={{
                                backgroundColor: store.currentTemplate.pageSettings.backgroundColor,
                                border: '1px solid transparent',
                                width: '30px',
                                height: '30px',
                                borderRadius: '4px',
                                marginRight: '4px',
                            }}
                        />
                        <input className={classes.input} type="text" style={{ width: '75px' }} name="selected_color" value={store.currentTemplate.pageSettings.backgroundColor} />

                        <img style={{ marginLeft: 15 }} src={color_picker} onClick={this.handleClickBackgroundColor} data-for="color" title="Pick Color" />

                        {this.state.displayBackgroundpicker ? (
                            <div style={styles.popover}>
                                <div style={styles.cover} onClick={this.handleCloseBackgroundColor} />
                                <ChromePicker color={store.currentTemplate.pageSettings.backgroundColor} onChange={this.handleOnChangeBackground} />
                            </div>
                        ) : null}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                            position: 'relative',
                        }}>
                        <span
                            className={classes.header}
                            style={{
                                width: '130px',
                            }}>
                            Color
                        </span>
                        <button
                            style={{
                                backgroundColor: store.currentTemplate.pageSettings.color,
                                border: '1px solid transparent',
                                width: '30px',
                                height: '30px',
                                borderRadius: '4px',
                                marginRight: '4px',
                            }}
                        />

                        <input className={classes.input} type="text" style={{ width: '75px' }} name="selected_color" value={store.currentTemplate.pageSettings.color} />

                        <img style={{ marginLeft: 15 }} src={color_picker} onClick={this.handleClickColor} data-for="color" title="Pick Color" />

                        {this.state.displayColorPicker ? (
                            <div style={styles.popover}>
                                <div style={styles.cover} onClick={this.handleCloseColor} />
                                <ChromePicker color={store.currentTemplate.pageSettings.color} onChange={this.handleOnChangeColor} />
                            </div>
                        ) : null}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                        }}>
                        <span
                            className={classes.header}
                            style={{
                                width: '130px',
                            }}>
                            Width
                        </span>
                        <div className={classes.inputBox}>
                            <input type="number" value={store.currentTemplate.pageSettings.width as number} onChange={(e) => (store.currentTemplate.pageSettings.width = +e.target.value)} min={600} max={800} step={10} className={classes.input} />
                        </div>
                        <div
                            className={classes.inputBox}
                            style={{
                                width: '130px',
                            }}>
                            <Slider className={classes.widthslider} value={store.currentTemplate.pageSettings.width} orientation="horizontal" min={600} max={800} step={10} onChange={this.handleOnChangeWidth} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default flowRight([withStyles(styles), observer])(ComponentsList);
